import React, { useState } from "react";
import "./Devis.css";
import { useTranslation, Trans } from "react-i18next";
import { sendContactEmail } from "../../services/email_service";

export default function Devis() {
  const { t } = useTranslation();

  const [sending, setSending] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [errors, setErrors] = useState({});

  // Sélections produits
  const [wantTelealarme, setWantTelealarme] = useState(false);
  const [wantPasserelle, setWantPasserelle] = useState(false);
  const [wantKube, setWantKube] = useState(false);

  const [qtyTelealarme, setQtyTelealarme] = useState("");
  const [qtyPasserelle, setQtyPasserelle] = useState("");
  const [qtyKube, setQtyKube] = useState("");

  // Service OPENlift (optionnel)
  const [serviceLevel, setServiceLevel] = useState("");

  const resetProductFieldsIfUnchecked = () => {
    if (!wantTelealarme) setQtyTelealarme("");
    if (!wantPasserelle) setQtyPasserelle("");
    if (!wantKube) setQtyKube("");
  };

  const validate = (payload) => {
    const e = {};
    if (!payload.prenom?.trim()) e.prenom = t("devis.validation.required");
    if (!payload.nom?.trim()) e.nom = t("devis.validation.required");
    if (!payload.email?.trim()) e.email = t("devis.validation.required");
    if (!payload.telephone?.trim()) e.telephone = t("devis.validation.required");
    if (!payload.entreprise?.trim()) e.entreprise = t("devis.validation.required");
    if (!payload.role?.trim()) e.role = t("devis.validation.required");
    if (!payload.nbAscenseurs?.trim()) e.nbAscenseurs = t("devis.validation.required");

    const anyProduct = wantTelealarme || wantPasserelle || wantKube;
    if (!anyProduct) e.products = t("devis.validation.choose_product");

    if (wantTelealarme && !payload.qtyTelealarme?.trim()) e.qtyTelealarme = t("devis.validation.enter_qty");
    if (wantPasserelle && !payload.qtyPasserelle?.trim()) e.qtyPasserelle = t("devis.validation.enter_qty");
    if (wantKube && !payload.qtyKube?.trim()) e.qtyKube = t("devis.validation.enter_qty");

    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError("");
    resetProductFieldsIfUnchecked();

    const data = new FormData(e.currentTarget);
    const form = Object.fromEntries(data.entries());

    const nextErrors = validate(form);
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    const products = [];
    if (wantTelealarme) products.push(`Téléalarme: ${form.qtyTelealarme}`);
    if (wantPasserelle) products.push(`Passerelle: ${form.qtyPasserelle}`);
    if (wantKube) products.push(`Kube: ${form.qtyKube}`);

    const payload = {
      firstname: form.prenom,
      name: form.nom,
      email: form.email,
      telephone: form.telephone,
      company: form.entreprise,
      role: form.role,
      company_type: form.typeOrg,
      number_of_elevator_in_fleet: Number(form.nbAscenseurs),
      subject: "Demande de devis",
      message: `
        Service level: ${serviceLevel || "N/A"}
        Produits demandés:
        ${products.join("\n")}

        Message:
        ${form.message || ""}`.trim(),
    };

    try {
      setSending(true);
      await sendContactEmail(payload);

      alert(t("devis.alert_success"));

      e.currentTarget.reset();
      setWantTelealarme(false);
      setWantPasserelle(false);
      setWantKube(false);
      setQtyTelealarme("");
      setQtyPasserelle("");
      setQtyKube("");
      setServiceLevel("");
    } catch (err) {
      console.error(err);
      setSubmitError(t("devis.submit_error"));
    } finally {
      setSending(false);
    }
  };


  return (
    <main className="page page-devis" aria-labelledby="devis-title">
      {/* ===== Hero simple (fond blanc) ===== */}
      <section className="devis-hero" role="region">
        <div className="devis-hero-inner">
          <header className="devis-hero-header">
            <h1 id="devis-title" className="devis-title">{t("devis.hero.title")}</h1>

            <p className="devis-subtitle">
              <Trans
                i18nKey="devis.hero.subtitle_html"
                components={{ strong: <strong /> }}
              />
            </p>
          </header>
        </div>
      </section>

      {/* ===== Cartes produits ===== */}
      <section className="devis-products" aria-label={t("devis.products.aria")}>
        <div className="container">
          <div className="products-grid">
            <article className="product-card" aria-labelledby="p-telealarme">
              <h2 id="p-telealarme" className="product-title">{t("devis.products.telealarme.title")}</h2>
              <p className="product-text">{t("devis.products.telealarme.text")}</p>
              <ul className="product-bullets">
                <li>{t("devis.products.telealarme.bullets.b1")}</li>
                <li>{t("devis.products.telealarme.bullets.b2")}</li>
                <li>{t("devis.products.telealarme.bullets.b3")}</li>
              </ul>
            </article>

            <article className="product-card" aria-labelledby="p-passerelle">
              <h2 id="p-passerelle" className="product-title">{t("devis.products.passerelle.title")}</h2>
              <p className="product-text">{t("devis.products.passerelle.text")}</p>
              <ul className="product-bullets">
                <li>{t("devis.products.passerelle.bullets.b1")}</li>
                <li>{t("devis.products.passerelle.bullets.b2")}</li>
                <li>{t("devis.products.passerelle.bullets.b3")}</li>
              </ul>
            </article>

            <article className="product-card" aria-labelledby="p-kube">
              <h2 id="p-kube" className="product-title">{t("devis.products.kube.title")}</h2>
              <p className="product-text">{t("devis.products.kube.text")}</p>
              <ul className="product-bullets">
                <li>{t("devis.products.kube.bullets.b1")}</li>
                <li>{t("devis.products.kube.bullets.b2")}</li>
                <li>{t("devis.products.kube.bullets.b3")}</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* ===== Formulaire devis ===== */}
      <section className="devis-form-section" aria-labelledby="form-title">
        <div className="container">
          <header className="form-header">
            <h2 id="form-title" className="form-title">{t("devis.form.title")}</h2>
            <p className="form-deck">{t("devis.form.deck")}</p>
          </header>

          <form className="devis-form" onSubmit={handleSubmit} noValidate>
            {/* Identité */}
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="prenom">{t("devis.form.fields.prenom.label")}</label>
                <input id="prenom" name="prenom" autoComplete="given-name" />
                {errors.prenom && <p className="field-error">{errors.prenom}</p>}
              </div>
              <div className="form-field">
                <label htmlFor="nom">{t("devis.form.fields.nom.label")}</label>
                <input id="nom" name="nom" autoComplete="family-name" />
                {errors.nom && <p className="field-error">{errors.nom}</p>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <label htmlFor="email">{t("devis.form.fields.email.label")}</label>
                <input id="email" type="email" name="email" autoComplete="email" />
                {errors.email && <p className="field-error">{errors.email}</p>}
              </div>
              <div className="form-field">
                <label htmlFor="telephone">{t("devis.form.fields.telephone.label")}</label>
                <input id="telephone" name="telephone" autoComplete="tel" />
                {errors.telephone && <p className="field-error">{errors.telephone}</p>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <label htmlFor="entreprise">{t("devis.form.fields.entreprise.label")}</label>
                <input id="entreprise" name="entreprise" autoComplete="organization" />
                {errors.entreprise && <p className="field-error">{errors.entreprise}</p>}
              </div>
              <div className="form-field">
                <label htmlFor="role">{t("devis.form.fields.role.label")}</label>
                <input
                  id="role"
                  name="role"
                  placeholder={t("devis.form.fields.role.placeholder")}
                />
                {errors.role && <p className="field-error">{errors.role}</p>}
              </div>
            </div>

            {/* Parc & contexte */}
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="typeOrg">{t("devis.form.fields.typeOrg.label")}</label>
                <select id="typeOrg" name="typeOrg" defaultValue="">
                  <option value="">{t("devis.form.fields.typeOrg.placeholder")}</option>
                  <option value="installateur">{t("devis.form.fields.typeOrg.options.installateur")}</option>
                  <option value="gestionnaire">{t("devis.form.fields.typeOrg.options.gestionnaire")}</option>
                  <option value="syndic">{t("devis.form.fields.typeOrg.options.syndic")}</option>
                  <option value="oem">{t("devis.form.fields.typeOrg.options.oem")}</option>
                  <option value="autre">{t("devis.form.fields.typeOrg.options.autre")}</option>
                </select>
              </div>
              <div className="form-field">
                <label htmlFor="nbAscenseurs">{t("devis.form.fields.nbAscenseurs.label")}</label>
                <input id="nbAscenseurs" name="nbAscenseurs" inputMode="numeric" />
                {errors.nbAscenseurs && <p className="field-error">{errors.nbAscenseurs}</p>}
              </div>
            </div>

            {/* Produits à chiffrer */}
            <fieldset className="fieldset" aria-labelledby="prod-legend">
              <legend id="prod-legend">{t("devis.form.products.legend")}</legend>
              <div className="checkbox-grid">
                <label className="check">
                  <input
                    type="checkbox"
                    name="wantTelealarme"
                    checked={wantTelealarme}
                    onChange={(e) => setWantTelealarme(e.target.checked)}
                  />
                  {t("devis.form.products.items.telealarme")}
                </label>
                <label className="check">
                  <input
                    type="checkbox"
                    name="wantPasserelle"
                    checked={wantPasserelle}
                    onChange={(e) => setWantPasserelle(e.target.checked)}
                  />
                  {t("devis.form.products.items.passerelle")}
                </label>
                <label className="check">
                  <input
                    type="checkbox"
                    name="wantKube"
                    checked={wantKube}
                    onChange={(e) => setWantKube(e.target.checked)}
                  />
                  {t("devis.form.products.items.kube")}
                </label>
              </div>
              {errors.products && <p className="field-error" role="alert">{errors.products}</p>}
            </fieldset>

            {/* Quantités conditionnelles */}
            <div className="form-row">
              {wantTelealarme ? (
                <div className="form-field">
                  <label htmlFor="qtyTelealarme">{t("devis.form.qty.telealarme.label")}</label>
                  <input
                    id="qtyTelealarme"
                    name="qtyTelealarme"
                    inputMode="numeric"
                    value={qtyTelealarme}
                    onChange={(e) => setQtyTelealarme(e.target.value)}
                  />
                  {errors.qtyTelealarme && <p className="field-error">{errors.qtyTelealarme}</p>}
                </div>
              ) : <div className="form-field empty" aria-hidden="true" />}

              {wantPasserelle ? (
                <div className="form-field">
                  <label htmlFor="qtyPasserelle">{t("devis.form.qty.passerelle.label")}</label>
                  <input
                    id="qtyPasserelle"
                    name="qtyPasserelle"
                    inputMode="numeric"
                    value={qtyPasserelle}
                    onChange={(e) => setQtyPasserelle(e.target.value)}
                  />
                  {errors.qtyPasserelle && <p className="field-error">{errors.qtyPasserelle}</p>}
                </div>
              ) : <div className="form-field empty" aria-hidden="true" />}
            </div>

            <div className="form-row">
              {wantKube ? (
                <div className="form-field">
                  <label htmlFor="qtyKube">{t("devis.form.qty.kube.label")}</label>
                  <input
                    id="qtyKube"
                    name="qtyKube"
                    inputMode="numeric"
                    value={qtyKube}
                    onChange={(e) => setQtyKube(e.target.value)}
                  />
                  {errors.qtyKube && <p className="field-error">{errors.qtyKube}</p>}
                </div>
              ) : <div className="form-field empty" aria-hidden="true" />}
            </div>

            {/* Message */}
            <div className="form-row">
              <div className="form-field" style={{ gridColumn: "1 / -1" }}>
                <label htmlFor="message">{t("devis.form.message.label")}</label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  placeholder={t("devis.form.message.placeholder")}
                />
              </div>
            </div>

            {/* Actions */}
            <div className="form-actions">
              <button type="submit" className="btn-solid" disabled={sending}>
                {sending ? t("devis.form.submit.sending") : t("devis.form.submit.label")}
              </button>
              {submitError && <p className="submit-error" role="alert">{submitError}</p>}
            </div>
          </form>
        </div>
      </section>

      {/* JSON-LD minimal pour SEO (page de type Contact/RequestQuote) */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": t("devis.jsonld.name"),
            "description": t("devis.jsonld.description"),
            "url": typeof window !== "undefined" ? window.location.href : "https://example.com/devis"
          })
        }}
      />
    </main>
  );
}
